(function () {
  function applyAccountText() {
    var text = window.fidelloMyAccountText;
    document.querySelectorAll('#nav-user a.toggle.mobile-hide').forEach(function (a) {
      var span = a.querySelector('.desktop-hide');
      if (text && span) {
        span.textContent = text;
      }
      if (!a.querySelector('.fidello-account-arrow')) {
        var arrow = document.createElement('span');
        arrow.className = 'fidello-account-arrow';
        arrow.setAttribute('aria-hidden', 'true');
        a.appendChild(arrow);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAccountText);
  } else {
    applyAccountText();
  }
})();
